import { useState, useEffect } from "react";
import { TYPO } from "styles/Typo";
import PerformanceHighcharts from "./PerformanceHighcharts";
import { exponential } from "utils/exp";
import { useRouter } from "next/router";
import { useStrategyIso } from "./Index";
import { trackPageAction } from "lib/analytics/core/actions";

export const calculrateReturnByLogReturn = (data: any) => {
  if (!data || data?.length === 0) return 0;
  const sum = data.reduce((acc: any, cur: any) => acc + cur, 0);
  return exponential(sum);
};
export const 누적합시리즈생성함수 = (data: any) => {
  let 누적합 = 0;
  const 누적합로그 = [
    ...data.map((d: any) => {
      누적합 += d;
      return 누적합;
    }),
  ];
  return [0, ...누적합로그.map((d: any) => exponential(d))];
};

export const sliceData = (data: any, period: string) => {
  switch (period) {
    case "3개월":
      return data.slice(-63);
    case "6개월":
      return data.slice(-126);
    case "1년":
      return data.slice(-252);
    case "전체":
      return data;
    default:
      return data;
  }
};
export const formatedDate = (
  date: string,
  router?: any,
  includeYear?: boolean
) => {
  if (!date) return;
  const year = date.slice(2, 4);
  const month = date.slice(5, 7);
  const day = date.slice(8, 10);
  if (includeYear) {
    return router?.locale === "en"
      ? `${year}.${Number(month)}`
      : `${year}년 ${Number(month)}월`;
  }
  return router?.locale === "en"
    ? `${Number(month)}.${Number(day)}`
    : `${Number(month)}월 ${Number(day)}일`;
};
function StrategyPerformanceCharts({
  logMock,
  kospiLogMock,
  nasdaqLogMock,
  realtimeData,
}: {
  logMock: any;
  kospiLogMock: any;
  nasdaqLogMock: any;
  realtimeData: any;
}) {
  const iso = useStrategyIso();
  const Button = ({
    name,
    active,
    handleClick,
    classname,
  }: {
    name: string;
    active: boolean;
    handleClick: () => void;
    classname?: string;
  }) => {
    return (
      <div className="grow h-[34px] ">
        <button
          data-gtm-id={`stPerfChartPeriod`}
          className={`${classname} hover:bg-gray2 ${TYPO.TYPO7_MD} ${
            active ? "bg-gray5 text-gray80" : "text-gray40 bg-white"
          } px-2 rounded-[8px] h-full w-full cursor-pointer`}
          onClick={handleClick}
        >
          {name}
        </button>
      </div>
    );
  };
  const router = useRouter();
  const defaultPeriod = "1년";
  const [period, setPeriod] = useState(defaultPeriod);
  const realTimeAssetLogMean = realtimeData?.assets?.length
    ? realtimeData.assets.reduce(
        (acc: number, curr: any) => acc + curr?.PRICE_CHG_LOG,
        0
      ) / realtimeData?.assets?.length
    : null;
  const realTimeKospiLog = realtimeData?.kospi
    ? realtimeData.kospi?.PRICE_CHG_LOG
    : null;

  const assetLogData = realtimeData?.assets?.length
    ? [
        ...logMock,
        {
          DAILY_CHG_LOG: realTimeAssetLogMean,
          BASE_DT: new Date().toISOString().split("T")[0],
        },
      ]?.filter((log: any) => log?.DAILY_CHG_LOG !== null)
    : logMock;

  const kospiLogData = realtimeData?.kospi
    ? [
        ...kospiLogMock,
        {
          DAILY_CHG_LOG: realTimeKospiLog,
          BASE_DT: new Date().toISOString().split("T")[0],
        },
      ]?.filter((log: any) => log?.DAILY_CHG_LOG !== null)
    : kospiLogMock;

  const nasdaqLogData = nasdaqLogMock;

  const [seriesData, setSeriesData] = useState(
    assetLogData
      ? 누적합시리즈생성함수([
          ...sliceData(assetLogData, defaultPeriod).map(
            (log: any) => log?.DAILY_CHG_LOG
          ),
        ])
      : []
  );
  const [rateOfReturn, setRateOfReturn] = useState(
    assetLogData
      ? calculrateReturnByLogReturn([
          ...sliceData(assetLogData, defaultPeriod).map(
            (log: any) => log?.DAILY_CHG_LOG
          ),
        ])
      : 0
  );
  const [xaxisData, setXaxisData] = useState(
    assetLogData
      ? [
          "시작",
          ...sliceData(assetLogData, defaultPeriod).map(
            (log: any) => log?.BASE_DT
          ),
        ]
      : []
  );
  const [kospiSeriesData, setKospiSeriesData] = useState(
    kospiLogData
      ? 누적합시리즈생성함수([
          ...sliceData(kospiLogData, defaultPeriod).map(
            (log: any) => log?.DAILY_CHG_LOG
          ),
        ])
      : []
  );
  const [nasdaqSeriesData, setNasdaqSeriesData] = useState(
    nasdaqLogData
      ? 누적합시리즈생성함수([
          ...sliceData(nasdaqLogData, defaultPeriod).map(
            (log: any) => log?.DAILY_CHG_LOG
          ),
        ])
      : []
  );
  //   console.log("seriesData", seriesData);
  //   console.log("rateOfReturn", rateOfReturn);
  //   console.log("xaxisData", xaxisData);

  const updateData = (period: string) => {
    setSeriesData(
      assetLogData
        ? 누적합시리즈생성함수([
            ...sliceData(assetLogData, period).map(
              (log: any) => log?.DAILY_CHG_LOG
            ),
          ])
        : []
    );
    setKospiSeriesData(
      kospiLogData
        ? 누적합시리즈생성함수([
            ...sliceData(kospiLogData, period).map(
              (log: any) => log?.DAILY_CHG_LOG
            ),
          ])
        : []
    );
    setNasdaqSeriesData(
      nasdaqLogData
        ? 누적합시리즈생성함수([
            ...sliceData(nasdaqLogData, period).map(
              (log: any) => log?.DAILY_CHG_LOG
            ),
          ])
        : []
    );
    setRateOfReturn(
      assetLogData
        ? calculrateReturnByLogReturn([
            ...sliceData(assetLogData, period).map(
              (log: any) => log?.DAILY_CHG_LOG
            ),
          ])
        : 0
    );
    setXaxisData(
      assetLogData
        ? [
            "시작",
            ...sliceData(assetLogData, period).map((log: any) => log?.BASE_DT),
          ]
        : []
    );
  };
  const periodConvertEng = (period: string) => {
    switch (period) {
      case "3개월":
        return "3-month";
      case "6개월":
        return "6-month";
      case "1년":
        return "1 year";
      case "전체":
        return "all";
      default:
        return "all";
    }
  };

  const indexSeriesData = iso === "US" ? nasdaqSeriesData : kospiSeriesData;

  return (
    <div className=" flex flex-col">
      <div className="flex flex-col gap-1 pl-6 pt-[30px]">
        <div className="flex items-center gap-1">
          {router.locale === "ko" && (
            <span className={`${TYPO.TYPO4_SB} text-gray80`}>
              {period === "전체" ? "오늘까지" : `${period}전보다`}
            </span>
          )}
          <span
            className={`st-perf-str-return ${TYPO.TYPO4_SB} ${
              rateOfReturn > 0
                ? "text-red40"
                : Number(rateOfReturn.toFixed(1)) === 0
                ? "text-gray50"
                : "text-blue40"
            }`}
          >
            {rateOfReturn > 0 ? "+" : ""}
            {rateOfReturn.toFixed(1)}%
          </span>{" "}
          {/* {router.locale === "ko" && (
            <span className={`${TYPO.TYPO4_SB} text-gray80`}>
              {rateOfReturn > 0 ? "올랐어요" : "내렸어요"}
            </span>
          )} */}
          {router.locale === "en" && (
            <span className={`${TYPO.TYPO4_SB} text-gray80`}>
              {`${rateOfReturn > 0 ? "gain" : "drop"} over ${periodConvertEng(
                period
              )} period`}
            </span>
          )}
        </div>
        <div className="flex items-center  gap-1">
          {router.locale === "ko" && (
            <span className={`${TYPO.TYPO7_MD} text-gray50`}>
              {iso === "US" ? "NASDAQ" : "KOSPI"}보다
            </span>
          )}

          <span
            className={`st-perf-kospi-return ${TYPO.TYPO7_MD} ${
              Number(
                (
                  seriesData?.[seriesData?.length - 1] -
                  indexSeriesData?.[indexSeriesData?.length - 1]
                ).toFixed(1)
              ) > 0
                ? "text-red40"
                : Number(
                    (
                      seriesData?.[seriesData?.length - 1] -
                      indexSeriesData?.[indexSeriesData?.length - 1]
                    ).toFixed(1)
                  ) === 0
                ? "text-gray40"
                : "text-blue40"
            }`}
          >
            {seriesData?.[seriesData?.length - 1] -
              indexSeriesData?.[indexSeriesData?.length - 1] >
            0
              ? "+"
              : ""}
            {(
              seriesData?.[seriesData?.length - 1] -
              indexSeriesData?.[indexSeriesData?.length - 1]
            ).toFixed(1)}
            %
          </span>
          {router.locale === "en" && (
            <span className={`${TYPO.TYPO7_MD} text-gray50`}>
              {`compared to ${iso === "US" ? "NASDAQ" : "KOSPI"}`}
            </span>
          )}
        </div>
      </div>
      <div className="flex flex-col px-6 py-2 gap-1">
        <PerformanceHighcharts
          seriesData={seriesData}
          kospiSeriesData={kospiSeriesData}
          nasdaqSeriesData={nasdaqSeriesData}
          xaxisData={xaxisData}
          period={period}
        />
      </div>
      <div className="flex items-center pb-6 px-5 gap-1">
        <Button
          name={router.locale === "ko" ? "3개월" : "3M"}
          classname="st-perf-btn-3m"
          active={period === "3개월"}
          handleClick={() => {
            trackPageAction("range_strat_chart");
            setPeriod("3개월");
            updateData("3개월");
          }}
        />
        <Button
          name={router.locale === "ko" ? "6개월" : "6M"}
          classname="st-perf-btn-6m"
          active={period === "6개월"}
          handleClick={() => {
            trackPageAction("range_strat_chart");
            setPeriod("6개월");
            updateData("6개월");
          }}
        />
        <Button
          name={router.locale === "ko" ? "1년" : "1Y"}
          classname="st-perf-btn-1y"
          active={period === "1년"}
          handleClick={() => {
            trackPageAction("range_strat_chart");
            setPeriod("1년");
            updateData("1년");
          }}
        />
        <Button
          name={router.locale === "ko" ? "전체" : "All"}
          classname="st-perf-btn-all"
          active={period === "전체"}
          handleClick={() => {
            trackPageAction("range_strat_chart");
            setPeriod("전체");
            updateData("전체");
          }}
        />
      </div>
    </div>
  );
}

export default StrategyPerformanceCharts;
